var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockGr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09EB65DE-074C-4967-B4B9-38ADA04CB18D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registruokit\\u0117s-tyrimui---N\\u0117ra-laik\\u0173",
    transform: "translate(-836.000000, -922.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(756.000000, 922.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock_gr",
    transform: "translate(80.000000, 0.000000)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ECEDF4",
    cx: 26.5,
    cy: 26.5,
    r: 16.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,0 C41.1355459,0 53,11.8644541 53,26.5 C53,41.1355459 41.1355459,53 26.5,53 C11.8644541,53 0,41.1355459 0,26.5 C0,11.8644541 11.8644541,0 26.5,0 Z M26.5,5 C14.6258779,5 5,14.6258779 5,26.5 C5,38.3741221 14.6258779,48 26.5,48 C38.3741221,48 48,38.3741221 48,26.5 C48,14.6258779 38.3741221,5 26.5,5 Z",
    id: "Oval-Copy-30",
    fill: "#DADBEA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DADBEA",
    style: {
      mixBlendMode: "multiply"
    },
    x: 24,
    y: 0,
    width: 5,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DADBEA",
    style: {
      mixBlendMode: "multiply"
    },
    x: 24,
    y: 25,
    width: 19,
    height: 5,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGr);
export default __webpack_public_path__ + "static/media/clock_gr.eeafeb28af6e7c7d006e0dda03eebf90.svg";
export { ForwardRef as ReactComponent };